/**
 * Created by vladislav on 05.10.2020
 */

const PlayButton = function () {
    cleverapps.EventEmitter.call(this);

    cleverapps.user.on("changePhysicalLevel", this.changePhysicalLevel.bind(this));

    cleverapps.eventBus.on("victoryRewardsReceive", () => {
        if (this.passedLevel) {
            this.animatePassLevel();
        }
    });

    this.update();
};

PlayButton.prototype = Object.create(cleverapps.EventEmitter.prototype);
PlayButton.prototype.constructor = PlayButton;

PlayButton.prototype.reset = function () {
    this.passedLevel = false;
    this.currentLevel = cleverapps.user.getCurrentLevel();
};

PlayButton.prototype.changePhysicalLevel = function () {
    if (this.incLevelDisabled) {
        return;
    }

    this.passedLevel = true;
    this.update();
};

PlayButton.prototype.enableIncLevel = function () {
    delete this.incLevelDisabled;
};

PlayButton.prototype.disableIncLevel = function () {
    this.incLevelDisabled = true;
};

PlayButton.prototype.getLevelNo = function () {
    const royalLeague = cleverapps.missionManager.findRunningMission(Mission.TYPE_ROYAL_LEAGUE);
    if (royalLeague) {
        return RoyalLeagueLevelsAdapter.getRound(royalLeague) + (this.passedLevel ? 0 : 1);
    }

    let levelNo = cleverapps.user.getVirtualLevel();
    if (this.passedLevel) {
        levelNo--;
    }
    return levelNo;
};

PlayButton.prototype.update = function () {
    const currentLevel = cleverapps.user.getCurrentLevel();
    if (this.currentLevel && this.currentLevel.episodeNo === currentLevel.episodeNo
        && this.currentLevel.levelNo === currentLevel.levelNo
        && this.currentLevel.getTag() === currentLevel.getTag()) {
        return;
    }

    if (this.currentLevel) {
        this.previousLevel = this.currentLevel;
    }

    this.currentLevel = currentLevel;

    this.trigger("update");
};

PlayButton.prototype.onClick = function () {
    if (cleverapps.forces.isRunningForce()) {
        cleverapps.forces.closeRunningForce();
    }

    if (Mission.TYPE_ROYAL_LEAGUE && cleverapps.missionManager.canManualStart(Mission.TYPE_ROYAL_LEAGUE)) {
        cleverapps.focusManager.display({
            focus: "RoyalLeagueStartWindow",
            action: function (f) {
                new RoyalLeagueStartWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
        return;
    }

    cleverapps.focusManager.display({
        focus: "PlayButton_scene",
        action: function (f) {
            Level.WantsToPlay(f);
        }
    });
};

PlayButton.prototype.animatePassLevel = function () {
    this.passedLevel = false;
    this.trigger("animatePassLevel");
};

PlayButton.prototype.showForce = function (f) {
    this.trigger("showForce", f);
};

cleverapps.InitByFeature["playbutton"] = function () {
    cleverapps.playButton = new PlayButton();
};